<div class="map-loader-backdrop" *ngIf="show"> 
    <div class="map-loader"
        [style.width]="size + 'px'"
        [style.height]="size + 'px'"
        [style.borderWidth]="weight + 'px'"
        [style.border-color]="fill"
        [style.border-bottom-color]="'transparent'"
    ></div>
</div>